var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"inset":"","dark":"","dense":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"white--text"},[_vm._v("Theme Dark")])]},proxy:true}]),model:{value:(_vm.$vuetify.theme.dark),callback:function ($$v) {_vm.$set(_vm.$vuetify.theme, "dark", $$v)},expression:"$vuetify.theme.dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }